/** Minimal BuJo rapid-log parsing (Ryder Carroll symbols). */

export const BUJO_LEGEND = [
  { sym: "•", label: "Tarea", hint: "algo a hacer" },
  { sym: "○", label: "Evento", hint: "cita, horario" },
  { sym: "-", label: "Nota", hint: "pensamiento suelto" },
  { sym: "!", label: "Prioridad", hint: "importante hoy" },
  { sym: ">", label: "Migrado", hint: "pasó a otro día" },
  { sym: "<", label: "Programado", hint: "para después" },
];

export function detectEntryType(raw) {
  const t = (raw || "").trim();
  if (!t) return null;
  if (/^\[x\]/i.test(t)) return { type: "task", done: true, text: t.replace(/^\[x\]\s*/i, "").trim() };
  if (/^\[ \]/.test(t)) return { type: "task", done: false, text: t.replace(/^\[ \]\s*/, "").trim() };
  if (/^•\s*/.test(t)) return { type: "task", done: false, text: t.replace(/^•\s*/, "").trim() };
  if (/^○\s*/.test(t)) return { type: "event", text: t.replace(/^○\s*/, "").trim() };
  if (/^!\s*/.test(t)) return { type: "focus", text: t.replace(/^!\s*/, "").trim() };
  if (/^-\s*|^—\s*/.test(t)) return { type: "note", text: t.replace(/^[-—]\s*/, "").trim() };
  if (/^>\s*/.test(t)) return { type: "migrated", text: t.replace(/^>\s*/, "").trim() };
  if (/^<\s*/.test(t)) return { type: "scheduled", text: t.replace(/^<\s*/, "").trim() };
  return null;
}

export const TYPE_TO_SYM = {
  task: "•",
  event: "○",
  focus: "!",
  note: "-",
  migrated: ">",
  scheduled: "<",
};

export function formatBujoLine(type, text, done = false) {
  const t = (text || "").trim();
  switch (type) {
    case "task":
      return done ? `[x] ${t}` : `• ${t}`;
    case "event":
      return `○ ${t}`;
    case "focus":
      return `! ${t}`;
    case "note":
      return `- ${t}`;
    case "migrated":
      return `> ${t}`;
    case "scheduled":
      return `< ${t}`;
    default:
      return `- ${t}`;
  }
}

export function parseDailyLog(content) {
  const entries = [];
  if (!content) return entries;
  content.split("\n").forEach((line, idx) => {
    const trimmed = line.trim();
    if (!trimmed) return;
    const detected = detectEntryType(trimmed) || { type: "note", text: trimmed, done: false };
    entries.push({ ...detected, lineIndex: idx, rawLine: line });
  });
  return entries;
}

export function isDiarioNote(title) {
  return (title || "").startsWith("Diario ·");
}
